export const css = {
	root: '_2lbaTFNb',
	nav_drawer: '_3WTpElVw',
	title: 'zgkQnsMG',
	' _key': 'ascm-theme/ascm/table-of-contents/drawer'
};

export default css;
